import * as React from 'react';

interface PageHeaderProps {
  kicker?: string;
  title: string;
  desc?: string;
  actions?: React.ReactNode;
}

export const PageHeader = ({ kicker, title, desc, actions }: PageHeaderProps) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
    <div>
      {kicker && (
        <div className="mb-1 font-mono text-xs font-medium uppercase tracking-[0.18em] text-faint">
          {kicker}
        </div>
      )}
      <h1 className="text-3xl font-bold text-foreground">{title}</h1>
      {desc && <p className="mt-1 max-w-2xl text-[13px] leading-relaxed text-muted">{desc}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
